import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc, collection, query, where, getDocs, setDoc, updateDoc, orderBy, addDoc, getFirestore } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import "./customerdashboard.css";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { motion } from "framer-motion";
import { storage } from "./firebase"; 


import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";





import { uploadBytes } from 'firebase/storage';
import {  serverTimestamp } from 'firebase/firestore';
import {  onAuthStateChanged } from "firebase/auth";
import { AnimatePresence } from 'framer-motion';




const CustomerDashboard = () => {
  const [selectedOption, setSelectedOption] = useState("profile"); 
  const [studentEmail, setStudentEmail] = useState("");
  const [profileData, setProfileData] = useState(null); // To store user data
  const [messageType, setMessageType] = useState("inquiry");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [notices, setNotices] = useState([]); // State to hold fetched notices
  const [assignmentDeadlines, setAssignmentDeadlines] = useState([]); // State to hold assignment deadlines
 

  //google classroom links
const [googleclassroomLink, setGoogleClassroomLink] = useState("")


  // Download course materials
  const [materials, setMaterials] = useState([]);


    // Dropdown button for assignments
  const [isLearningDropdownOpen, setLearningDropdownOpen] = useState(false);
  const toggleLearningDropdown = () => {
    setLearningDropdownOpen(!isLearningDropdownOpen);
  };

  


  // Dropdown button for assignments
  const [isAssignmentDropdownOpen, setAssignmentDropdownOpen] = useState(false);
  const toggleAssignmentDropdown = () => {
    setAssignmentDropdownOpen(!isAssignmentDropdownOpen);
  };


//result dropdown
  const [isResultsDropdownOpen, setResultsDropdownOpen] = useState(false);
  const toggleResultsDropdown = () => {
    setResultsDropdownOpen(!isResultsDropdownOpen);
  };


  // Assignment state
  const [assignments, setAssignments] = useState([]); // Assignments to display

  // Course modules
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // User Registration ID is fetched properly from profileData
  const userRegistrationId = profileData?.registrationNumber;
  const userBatch = profileData?.batch;  // User's batch

  const auth = getAuth();
  const navigate = useNavigate();

  // Student result
  const [results, setResults] = useState([]);

//assignment upload only three times
const [uploadProgress, setUploadProgress] = useState(0);
const [isUploading, setIsUploading] = useState(false);
const [uploadAttempts, setUploadAttempts] = useState({}); // Track upload attempts per module

  // Student payment
  const [payments, setPayments] = useState([]);
  const [courseFee, setCourseFee] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);

//fetch quiz link
const [quizLinks, setQuizLinks] = useState([]);
const [userRegistrationNumber, setUserRegistrationNumber] = useState("");


//fetch lecture recording links
const [lectureRecordingLink, setLectureRecordingLink] = useState("")




  const currentUserEmail = auth.currentUser?.email;



  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };






//  // Snowflake generator
//  useEffect(() => {
//   const createSnowflake = () => {
//     const snowflake = document.createElement("div");
//     snowflake.className = "snowflake";
//     snowflake.style.left = Math.random() * 100 + "vw";
//     snowflake.style.animationDuration = Math.random() * 3 + 2 + "s"; // Varying speed
//     snowflake.style.opacity = Math.random(); // Varying opacity
//     document.body.appendChild(snowflake);

//     setTimeout(() => {
//       snowflake.remove();
//     }, 5000); // Remove snowflake after animation
//   };

//   const interval = setInterval(createSnowflake, 100); // Create a snowflake every 100ms
//   return () => clearInterval(interval); // Cleanup interval on unmount
// }, []);


  const [user, setUser] = useState(null);
  const [activeForm, setActiveForm] = useState('installment'); 
  const [formData, setFormData] = useState({ 
    email: '',
    name: '',
    course: '',
    moduleName: '',
    contactNo: '',
    nicPassportNo: '',
    additional: '',
    applicationFile: null,
    paymentSlipFile: null,
  });






  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };


    
  // Handle change for course and module
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset module if course is changed
    if (name === "installment") {
      setFormData((prev) => ({
        ...prev,
        course: value,
        moduleName: "", // reset module
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const stateName = name === 'application' ? 'applicationFile' : 'paymentSlipFile';
    
    setFormData((prevData) => ({
      ...prevData,
      [stateName]: files[0],
    }));
  };

  const validateFiles = () => {
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    
    // Only validate application file for exam fee
    // if (activeForm === 'exam' && !formData.applicationFile) {
    //   return 'Please fill the exam application ';
    // }
    
    if (!formData.paymentSlipFile) {
      return 'Please upload the payment slip';
    }
    

    
    if (formData.paymentSlipFile.size > MAX_SIZE) {
      return 'Payment slip is too large (max 5MB)';
    }
    
    return null;
  };







  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);

    const validationError = validateFiles();
    if (validationError) {
      setSubmitError(validationError);
      setIsSubmitting(false);
      return;
    }

    try {
      const storage = getStorage();
      
      // Upload payment slip
      const paymentFileName = `payment_${Date.now()}_${formData.paymentSlipFile.name}`;
      const paymentRef = ref(storage, `formSubmissions/${paymentFileName}`);
      await uploadBytes(paymentRef, formData.paymentSlipFile);
      const paymentSlipUrl = await getDownloadURL(paymentRef);

      // Only upload application file if it exists (mainly for exam fee)
      let applicationFileUrl = '';
      let appFileName = '';
      if (formData.applicationFile) {
        appFileName = `application_${Date.now()}_${formData.applicationFile.name}`;
        const applicationRef = ref(storage, `formSubmissions/${appFileName}`);
        await uploadBytes(applicationRef, formData.applicationFile);
        applicationFileUrl = await getDownloadURL(applicationRef);
      }

      // Save text data to Firestore
      const submissionData = {
        name: formData.name,
        email: formData.email,
        course: formData.course,
        moduleName:formData.moduleName,
        contactNo: formData.contactNo,
        nicPassportNo: formData.nicPassportNo,
        additional: formData.additional,
        paymentFileName: paymentFileName,
        paymentSlipUrl,
        submittedAt: serverTimestamp(),
        status: 'pending',
        feeType: activeForm
      };

      // Only include application file data if it exists
      if (formData.applicationFile) {
        submissionData.applicationFileName = appFileName;
        submissionData.applicationFileUrl = applicationFileUrl;
      }

      await addDoc(collection(db, 'formSubmissions'), submissionData);

      // Prepare email data
      const emailData = {
        name: formData.name,
        email: formData.email,
        course: formData.course,
        moduleName:formData.moduleName,
        contactNo: formData.contactNo,
        nicPassportNo: formData.nicPassportNo,
        additional: formData.additional,
        paymentSlipUrl,
        feeType: activeForm
      };

      // Include application file in email if it exists
      if (formData.applicationFile) {
        emailData.applicationFileUrl = applicationFileUrl;
        emailData.applicationFileName = appFileName;
      }

      await emailjs.send(
        'service_f5biz1g',
        'template_syi85z9',
        emailData,
        '0tqu3JXAHOi2utnXT'
      );
  

      setSubmitSuccess(true);
      setFormData({
        email: '',
        name: '',
        course: '',
        moduleName: '',
        contactNo: '',
        nicPassportNo: '',
        additional: '',
        applicationFile: null,
        paymentSlipFile: null,
      });
       setIsSubmitted(true);   // ✅ SHOW THANK YOU MESSAGE
       setIsSubmitting(false);
    } catch (err) {
      console.error('Failed to submit registration:', err);
      setSubmitError(`Failed to submit registration: ${err.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };





  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Form variants for animation
  const formVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -50 }
  };

  // Button variants for animation
  const buttonVariants = {
    active: { backgroundColor: "#4CAF50", color: "white" },
    inactive: { backgroundColor: "#f5f5f5", color: "#333" }
  };










  // Fetch the logged-in user's email
  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      setStudentEmail(user.email);
    }
  }, [auth.currentUser]);



  

  // Handle Send Message with EmailJS
  const handleSend = (e) => {
    e.preventDefault();

    const templateParams = {
      student_email: studentEmail, // Sender's email
      message_type: messageType, // Selected message type
      subject, // Subject of the message
      message, // Message body
    };

    emailjs
      .send(
        "service_f5biz1g", // Replace with your EmailJS service ID
        "template_syi85z9", // Replace with your EmailJS template ID
        templateParams,
        "0tqu3JXAHOi2utnXT" // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          handleClear(); // Clear the form after sending
        },
        (error) => {
          console.error("Failed to send message:", error);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  // Handle Clear Form
  const handleClear = () => {
    setMessageType("inquiry");
    setSubject("");
    setMessage("");
  };














////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




  // Fetch the currently logged-in user's email and profile data from Firestore
  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;

      if (user) {
        setStudentEmail(user.email);

        // Fetch user details from Firestore
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setProfileData(docSnap.data());
        } else {
          console.error("No user data found!");
        }
      }
    };

    fetchUserData();
  }, [auth.currentUser]);













const [purchasedItems, setPurchasedItems] = useState([]);

useEffect(() => {
  const fetchPurchasedItems = async () => {
    try {
      setLoading(true);
      const user = auth.currentUser;

      if (!user) {
        console.error("No user logged in.");
        setLoading(false);
        return;
      }

      // Query the Firestore collection
      const q = query(
        collection(db, "purchased_products"),
        where("email", "==", user.email)
      );

      const querySnapshot = await getDocs(q);

      const items = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setPurchasedItems(items);
    } catch (error) {
      console.error("Error fetching purchased items:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchPurchasedItems();
}, []);


// --- PDF Download ---
{/* --- PDF Download Function --- */}
const handleDownload = (product) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Map fields to avoid undefined errors
  const selectedProduct = product.productName || "-";
  const productCode = product.productCode || "-";
  const quantitySold = product.quantitySold || "";
  const productPrice = product.productPrice || "0";
  const finalAmount = product.finalAmount || "0";
  const invoiceNumber = product.invoiceNumber || "NoNumber";
  const date = product.date || "-";
  const customerName = product.customerName || "-";
  const email = product.email || "-";
  const company = product.company || "-";
  const paymentType = product.paymentType || "-";
  const advancePayment = product.advancePayment || "0";
  const installmentMonths = product.installmentMonths || "-";
  const eachInstallment = product.eachInstallment || "0";
  const remark = product.remark || "-";

  // ✅ Watermark
  const watermarkLogo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  const logoWidth = 140;
  const logoHeight = 100;
  const x = (pageWidth - logoWidth) / 2;
  const y = (pageHeight - logoHeight) / 2;
  doc.setGState(new doc.GState({ opacity: 0.1 }));
  doc.addImage(watermarkLogo, "JPEG", x, y, logoWidth, logoHeight, "", "SLOW");
  doc.setGState(new doc.GState({ opacity: 1 }));

  // ✅ Header
  const headerHeight = 40;
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, headerHeight, "F");
  const logo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  doc.addImage(logo, "JPEG", 5, 10, 60, 25);
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(16);
  doc.text("OPTICA INTERNATIONAL", 75, 15);
  doc.setFontSize(8);
  doc.text("932, Maradana Road, Colombo 08", 75, 23);
  doc.text(" 011 268 2277 / 077 344 0937 | opticainternational@gmail.com", 75, 29);

  // ✅ Footer
  const footerHeight = 20;
  doc.setFillColor(0, 0, 0);
  doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text(
    "Thank you for your purchase!",
    pageWidth / 2,
    pageHeight - 8,
    { align: "center" }
  );

  // ✅ Purchase Details
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(12);
  let contentY = headerHeight + 15;
  doc.text(`Invoice No: ${invoiceNumber}`, 14, contentY);
  doc.text(`Date: ${date}`, pageWidth - 60, contentY);
  contentY += 10;
  doc.text(`Customer: ${customerName}`, 14, contentY);
  contentY += 8;
  doc.text(`Email: ${email}`, 14, contentY);
  contentY += 8;
  doc.text(`Company: ${company}`, 14, contentY);

  // ✅ Product Table
  const tableColumn = ["Product Name", "Product Code", "Qty", "Unit Price (Rs.)", "Total Amount"];
  const tableRows = [[selectedProduct, productCode, quantitySold, productPrice, finalAmount]];
  autoTable(doc, {
    startY: contentY + 10,
    head: [tableColumn],
    body: tableRows,
    styles: { halign: "center" },
    headStyles: { fillColor: [0, 0, 0], textColor: 255 },
  });

  let finalY = doc.lastAutoTable.finalY + 10;
  doc.text(`Payment Type: ${paymentType}`, 14, finalY);
  doc.text(`Qty: ${quantitySold}`, 14, finalY + 8 );
   doc.text(`Unit Price: ${productPrice}`, 14, finalY + 16 );
  doc.text(`Total Amount: ${finalAmount}`, 14, finalY + 24);  
  if (paymentType === "installment") {
    doc.text(`Advance Payment: Rs.${advancePayment}`, 14, finalY + 32);
    doc.text(`Installment Months: ${installmentMonths}`, 14, finalY + 40);
    doc.text(`Each Installment: Rs.${eachInstallment}`, 14, finalY + 48);
    finalY += 30;
  }

  if (remark) {
    doc.text(`Remark: ${remark}`, 14, finalY + 30);
  }

  doc.save(`Invoice_${invoiceNumber}.pdf`);
};




 


/////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [paymentsData, setPaymentsData] = useState([]);

  // Fetch all payments and related purchased_products
  const fetchPayments = async () => {
    setLoading(true);
    try {
      // 1️⃣ Fetch purchased_products for this customer
      const purchasedSnap = await getDocs(
        query(collection(db, "purchased_products"), where("email", "==", currentUserEmail))
      );
      const purchasedData = purchasedSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      // 2️⃣ Fetch payments for this customer
      const paymentsSnap = await getDocs(
        query(collection(db, "payments"), where("email", "==", currentUserEmail))
      );
      const payments = paymentsSnap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      // 3️⃣ Merge payments with purchased_products by productCode
      const mergedData = purchasedData.map((purchase) => {
        const productPayments = payments.filter(
          (p) => p.productCode === purchase.productCode
        );
        return { ...purchase, payments: productPayments };
      });

      setPaymentsData(mergedData);
    } catch (error) {
      console.error("Error fetching payments:", error);
      alert("Failed to fetch payments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedOption === "payment") {
      fetchPayments();
    }
  }, [selectedOption]);




///////////////////////////////download payment record ////////////////////////////////////


const handlePaymentSlipDownload = async (purchase) => {
    const paymentsQuery = query(
    collection(db, "payments"),
    where("purchaseId", "==", purchase.id)
  );
  const snapshot = await getDocs(paymentsQuery);
  const payments = snapshot.docs.map((d) => d.data());

  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();



  // -------------------- WATERMARK --------------------
  const watermarkLogo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  doc.setGState(new doc.GState({ opacity: 0.1 }));
  doc.addImage(watermarkLogo, "JPEG", (pageWidth - 140) / 2, (pageHeight - 100) / 2, 140, 100, "", "SLOW");
  doc.setGState(new doc.GState({ opacity: 1 }));

  
  // -------------------- HEADER --------------------
  doc.setFillColor(0, 0, 0);
  doc.rect(0, 0, pageWidth, 40, "F");
  const logo = `${process.env.PUBLIC_URL}/optica-no-bg.png`;
  try { doc.addImage(logo, "JPEG", 5, 10, 60, 25); } catch {}
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.text("OPTICA INTERNATIONAL", 75, 15);
  doc.setFontSize(8);
  doc.text("932, Maradana Road, Colombo 08", 75, 23);
  doc.text("011 268 2277 / 077 344 0937 | opticainternational@gmail.com", 75, 29);


  // -------------------- TITLE --------------------
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(14);
  doc.text("PAYMENT STATEMENT", pageWidth / 2, 55, { align: "center" });

  // -------------------- PAYMENT TABLE --------------------
  const tableStartY = 65;
  const tableColumn = ["#", "Payment Date", "Installment Amount (Rs.)"];
  const tableRows = payments.map((p, index) => [
    index + 1,
    p.paymentDate || "-",
    Number(p.installmentAmount || 0).toLocaleString(),
  ]);

  autoTable(doc, {
    startY: tableStartY,
    head: [tableColumn],
    body: tableRows,
    headStyles: { fillColor: [0, 0, 0], textColor: 255, halign: "center" },
    styles: { halign: "center", fontSize: 10 },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    margin: { left: 14, right: 14 },
    didDrawPage: (data) => {
      // Optional: Add header/footer per page if needed
    },
  });

  const tableEndY = doc.lastAutoTable.finalY + 10;

  // -------------------- SUMMARY --------------------//

  const labelX = 14;
  const valueX = pageWidth / 2;
  let detailsY = tableEndY;
  const lineGap = 8;

  const totalPaidInstallments = payments.reduce((sum, p) => sum + (Number(p.installmentAmount) || 0), 0);
  const totalPaid = (purchase.advancePayment || 0) + totalPaidInstallments;
  const outstanding = Math.max((purchase.finalAmount || 0) - totalPaid, 0);

  const statementFields = [
    ["Customer Name", purchase.customerName || "-"],
    ["Company", purchase.company || "-"],
    ["Email", purchase.email || "-"],
    ["Product Name", purchase.productName || "-"],
    ["Product Code", purchase.productCode || "-"],
    ["Invoice Number", purchase.invoiceNumber || "-"],
    ["Payment Type", purchase.paymentType || "-"],
    ["Unit Price", `Rs.${(purchase.productPrice || 0).toLocaleString()}`],
    ["Qty", `Rs.${(purchase.quantitySold || 0).toLocaleString()}`],
    ["Total Amount", `Rs.${(purchase.finalAmount || 0).toLocaleString()}`],
    ["Advance Payment", `Rs.${(purchase.advancePayment || 0).toLocaleString()}`],
    ["No of Installments", purchase.installmentMonths || "-"],
    ["Each Installment", `Rs.${purchase.eachInstallment || 0}`],
    ["Total Installments Paid", `Rs.${totalPaidInstallments.toLocaleString()}`],
    ["Total Paid Amount", `Rs.${totalPaid.toLocaleString()}`],
    ["Outstanding Amount", `Rs.${outstanding.toLocaleString()}`],
  ];

  statementFields.forEach(([label, value]) => {
    // Add new page if summary goes beyond page
    if (detailsY > pageHeight - 30) {
      doc.addPage();
      detailsY = 20; // top margin
    }

    doc.setFont("helvetica", "bold");
    doc.text(`${label}:`, labelX, detailsY);
    doc.setFont("helvetica", "normal");
    doc.text(String(value || "-"), valueX, detailsY);
    doc.setDrawColor(200);
    doc.line(labelX, detailsY + 2, pageWidth - 14, detailsY + 2);
    detailsY += lineGap;
  });


  // -------------------- FOOTER --------------------//

  const footerHeight = 20;
  doc.setFillColor(0, 0, 0);
  doc.rect(0, pageHeight - footerHeight, pageWidth, footerHeight, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.text("Thank you for your purchase!", pageWidth / 2, pageHeight - 8, { align: "center" });

  // -------------------- SAVE PDF --------------------
  doc.save(`PaymentSlip_${purchase.invoiceNumber || "NoNumber"}.pdf`);
};













/////////////////////////////// view own submited payments
  const [submits, setSubmits] = useState([]);
  const db = getFirestore();

  useEffect(() => {
    const fetchSubmits = async () => {
      const user = auth.currentUser;
      if (!user) {
        setLoading(false);
        return;
      }

      const userEmail = user.email;
      const submissionRef = collection(db, "formSubmissions");
      const q = query(submissionRef, where("email", "==", userEmail));

      try {
        const querySnapshot = await getDocs(q);
        const submissionList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSubmits(submissionList);
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }

      setLoading(false);
    };

    fetchSubmits();
  }, []);





   // Add this function to update status in Firestore
   const updateStatus = async (submissionId, newStatus) => {
    try {
      await updateDoc(doc(db, "formSubmissions", submissionId), {
        status: newStatus,
        updatedAt: new Date()
      });
      
      // Update local state to reflect changes immediately
      setSubmits(submits.map(sub => 
        sub.id === submissionId ? { ...sub, status: newStatus } : sub
      ));
      
      alert(`Status updated to ${newStatus}`);
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status");
    }
  };







  return (
      <div className="student-dashboard-container">

      {/* <div id="snow-container" className="student-dashboard-container">
      
      <div className="santa-container">
        <img src="/santaimg.png" alt="Santa with Reindeer and Cart" className="santa" />
      </div>*/}
{/* 
<div className="sun-overlay">
            <div className="sun-container">
              <img src="/sun.png" alt="Sun with New Year" className="sun" />
            </div>
          </div> */}

          {/* <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div>

          <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div> */}



       <div className="student-sidebar">
         <h2 className="student-sidebar-title">Optica International - Customer Dashboard</h2>
         <ul className="student-sidebar-list">
   
           <li onClick={() => setSelectedOption("profile")}>My Profile</li>
           <li onClick={() => setSelectedOption("purchasedItem")}>My Purchased Products</li>
           <li onClick={() => setSelectedOption("payment")}>My Payments</li>
           <li onClick={() => setSelectedOption("paymentSubmission")}>Payment Submission</li>
           <li onClick={() => setSelectedOption("viewsubmitedpayments")}>View My Payment Submissions</li>
           <li onClick={() => setSelectedOption("letter")}>Inquiry</li>
           <li className="logout-button" onClick={handleLogout}>Logout</li>
         </ul>
       </div>



      {/* Main Panel */}
      <div className="student-panel">
        





{/*************************************************** payment submission **************************************************************/}
{selectedOption === "paymentSubmission" && (
  <div className="application-download">

    <h1 className="student-panel-title">Upload Payment Slip</h1>

    <p className="student-guidlines-description">
      Please select the type of payment you wish to submit. Choose between Installment Payment,
      or other Payment and fill out the corresponding form with your details and payment slip.
    </p>

    {/* Fee Type Buttons */}
    {!isSubmitted && (
      <div className="fee-type-buttons">
        <motion.button
          variants={buttonVariants}
          animate={activeForm === "installment" ? "active" : "inactive"}
          onClick={() => setActiveForm("installment")}
          className="fee-button"
        >
          Installment Payment
        </motion.button>

        <motion.button
          variants={buttonVariants}
          animate={activeForm === "other" ? "active" : "inactive"}
          onClick={() => setActiveForm("other")}
          className="fee-button"
        >
          Other
        </motion.button>
      </div>
    )}

    {/* ✅ THANK YOU MESSAGE (AFTER SUBMIT ONLY) */}
    {isSubmitted ? (
      <div className="success-message">
        <h3 className="download-heading-form">Thank you for your submission!</h3>
        <p>
          Your <strong>{activeForm}</strong> payment has been received successfully.
          We will review it and get back to you soon.
        </p>
      </div>
    ) : (
      <AnimatePresence mode="wait">
        <motion.div
          key={activeForm}
          variants={formVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
          transition={{ duration: 0.3 }}
          className="form-container"
        >
          <form className="submission-form" onSubmit={handleSubmit}>
            <h2 className="form-title">
              {activeForm === 'installment' && 'Installment Payment'}
              {activeForm === 'other' && 'Other Payment'}
            </h2>

            <div className="form-group">
              <label htmlFor="fullName">Full Name *</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                placeholder="Enter your full name" 
                value={formData.name}
                onChange={handleChange}
                required 
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="example@email.com" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </div>

           
            <div className="form-group">
              <label htmlFor="contactNo">Contact Number *</label>
              <input 
                type="tel" 
                id="contactNo" 
                name="contactNo" 
                placeholder="+94 77 123 4567" 
                value={formData.contactNo}
                onChange={handleChange}
                required 
              />
            </div>

            <div className="form-group">
              <label htmlFor="nicPassportNo">NIC Number *</label>
              <input 
                type="text" 
                id="nicPassportNo" 
                name="nicPassportNo" 
                placeholder="199012345678 or 901234567V" 
                value={formData.nicPassportNo}
                onChange={handleChange}
                required 
              />
            </div>

            {/* Payment Slip Upload */}
            <div className="form-group file-upload">
              <label htmlFor="paymentSlip">
                {activeForm === 'installment' && 'Upload Payment Slip*'}
                {activeForm === 'other' && 'Upload Payment Slip *'}
              </label>

              <div style={{ position: 'relative', margin: '20px 0' }}>
                <input 
                  type="file" 
                  id="paymentSlip" 
                  name="paymentSlip"
                  style={{
                    position: 'relative',
                    display: 'block',
                    width: '100%',
                    padding: '15px',
                    border: '2px solid blue',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    zIndex: 1000,
                    opacity: 1,
                    visibility: 'visible'
                  }}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  onChange={handleFileChange}
                  required 
                />
              </div>

              {formData.paymentSlipFile && (
                <div className="file-info">
                  Selected: {formData.paymentSlipFile.name} ({Math.round(formData.paymentSlipFile.size / 1024)} KB)
                </div>
              )}
              <small>Max file size: 5MB</small>
            </div>

            <div className="form-group">
              <label htmlFor="additional">Additional Comments</label>
              <textarea 
                id="additional" 
                name="additional" 
                placeholder="Any special instructions or notes..." 
                value={formData.additional}
                onChange={handleChange}
                rows="4"
              ></textarea>
            </div>

            {submitError && <div className="error-message">{submitError}</div>}

            <button 
              type="submit" 
              className="submit-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : `Submit ${activeForm.charAt(0).toUpperCase() + activeForm.slice(1)} Payment`}
            </button>

          </form>
        </motion.div>
      </AnimatePresence>
    )}
    </div>

)}




{/*************************************************** view own payment submissions **************************************************************/}


    {selectedOption === "viewsubmitedpayments" && (
    <div className="submissions-container">
      <h1 className="student-panel-title">My Payment Submissions</h1>
    <table className="submission-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>NIC/Passport No</th>
          <th>Email</th>
          <th>Contact</th>
          <th>Status</th>
          <th>Submitted At</th>
          <th>Payment Slip</th>
   
  
        </tr>
      </thead>
      <tbody>
        {submits.map((submission) => (
          <tr key={submission.id} className="submission-row">
            <td data-label="Name">{submission.name}</td>
            <td data-label="NIC/Passport">{submission.nicPassportNo}</td>
            <td data-label="Email">{submission.email}</td>
            <td data-label="Contact">{submission.contactNo}</td>
            <td data-label="Status">
              <span className={`status-badge ${submission.status?.toLowerCase() || 'pending'}`}>
                {submission.status || 'Pending'}
              </span>
            </td>
            <td data-label="Submitted At">
              {submission.submittedAt?.toDate().toLocaleString()}
            </td>


            <td data-label="Payment Slip">
              <a 
                href={submission.paymentSlipUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="file-link"
                title={`Download payment: ${submission.paymentFileName}`}
              >
                <span className="file-icon">💳</span> Payment
              </a>
            </td>
    
         

          </tr>
        ))}
      </tbody>
    </table>

    {loading && (
      <div className="loading-indicator">
        <div className="spinner"></div>
        <p>Loading submissions...</p>
      </div>
    )}
    
    {!loading && submits.length === 0 && (
      <div className="empty-state">
        <img src="/empty-folder.png" alt="No submissions" />
        <h3>No submissions found</h3>
        <p>There are currently no submissions to display.</p>
      </div>
    )}
  </div>

    )}





















{/*************************************************** customer Profile **************************************************************/}



                  {selectedOption === "profile" && (
                    <div className="student-profile-second">
                      <h1 className="student-panel-title">Customer Profile</h1>
                      {profileData ? (
                        <div className="profile-details">

                        <div className="profile-row">
                            <strong>Name :</strong> <span>{profileData.nameWithInitial}</span>
                          </div>

                          <div className="profile-row">
                            <strong>Company Name :</strong> <span>{profileData.companyname}</span>
                          </div>

                          <div className="profile-row">
                            <strong>Email :</strong> <span>{profileData.email}</span>
                          </div>
                          <div className="profile-row">
                            <strong>NIC/Passport :</strong> <span>{profileData.nicPassport}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Contact no :</strong> <span>{profileData.contactNo}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Address :</strong> <span>{profileData.address}</span>
                          </div>

                                    </div>
                                  ) : (
                                    <p className="loading-text">Loading profile data...</p>
                                  )}
                                                {/* Lock Image */}
                                                <img
                                    src={`${process.env.PUBLIC_URL}/imglock.png`}
                                    alt="Profile Lock"
                                    className="profile-lock-image"
                                  />
                                </div>
                    )}

{/*************************************************** Purchased Items **************************************************************/}



{/* Purchased Products Table */}
{selectedOption === "purchasedItem" && (
  <div className="purchased-items-container">
    <h1 className="heading-purchased-item">My Purchased Products</h1>

    {loading ? (
      <p>Loading your purchases...</p>
    ) : purchasedItems.length === 0 ? (
      <p>No purchased items found.</p>
    ) : (
      <div className="purchased-table-container">
        <table className="purchased-table">
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Company</th>
              <th>Product Name</th>
              <th>Product Code</th>
              <th>Payment Type</th>
              <th>Advance Payment (Rs.)</th>
              <th>Each Installment (Rs.)</th>
              <th>Installment Months</th>
              <th>Product Price (Rs.)</th>
              <th>Remark</th>
              <th>Purchased On</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {purchasedItems.map((item) => (
              <tr key={item.id}>
                <td>{item.customerName || "-"}</td>
                <td>{item.company || "-"}</td>
                <td>{item.productName || "-"}</td>
                <td>{item.productCode || "-"}</td>
                <td>{item.paymentType || "-"}</td>
                <td>{item.advancePayment || "-"}</td>
                <td>{item.eachInstallment || "-"}</td>
                <td>{item.installmentMonths || "-"}</td>
                <td>{item.productPrice || "-"}</td>
                <td>{item.remark || "N/A"}</td> 
  <td>
  {item.date
    ? new Date(item.date.seconds ? item.date.seconds * 1000 : item.date).toLocaleDateString()
    : "-"}
</td>
                <td>
                  <button
                    style={{ background: "#023a7a", color: "#fff", padding: "5px 10px", borderRadius: "4px" }}
                    onClick={() => handleDownload(item)}
                  >
                    Download
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
)}



{/*************************************************** Payments **************************************************************/}




{selectedOption === "payment" && (
  <div className="customer-payment-container">
    <h1 className="customer-payment-title">My Payments</h1>
    {loading ? (
      <p>Loading payments...</p>
    ) : paymentsData.length === 0 ? (
      <p>No payments found.</p>
    ) : (
      <div className="customer-payment-table-wrapper">
        <table className="customer-payment-table">
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Company</th>
              <th>Email</th>
              <th>Product Name</th>
              <th>Product Code</th>
              <th>Invoice No</th>
              <th>Qty</th>
              <th>Unit Price</th>
              <th>Total Amount</th>
              <th>Advance Payment</th>
              <th>No. of Installments</th>
              <th>Each Installment</th>
              <th>Total Paid Amount </th> 
              <th>Outstanding Amount</th>
              <th>Action</th>
            </tr>
          </thead>
<tbody>
  {paymentsData.map((purchase) => {
    const totalPaid =
      (purchase.advancePayment || 0) + (purchase.installmentsPaidAmount || 0);
    const outstanding =
      (purchase.finalAmount || 0) - totalPaid;

    return (
      <tr key={purchase.id}>
        <td>{purchase.customerName}</td>
        <td>{purchase.company}</td>
        <td>{purchase.email}</td>
        <td>{purchase.productName}</td>
        <td>{purchase.productCode}</td>
        <td>{purchase.invoiceNumber}</td>
        <td>{purchase.quantitySold}</td>
        <td>{purchase.productPrice}</td>
        <td>{purchase.finalAmount}</td>
        <td>{purchase.advancePayment || 0}</td>
        <td>{purchase.installmentMonths || "-"}</td>
        <td>{purchase.eachInstallment || 0}</td>

        {/* ✅ Corrected Total Amount Paid */}
        <td>{totalPaid}</td>

        {/* ✅ Corrected Outstanding Amount */}
        <td>{outstanding < 0 ? 0 : outstanding}</td>

        <td>
          <button
            className="customer-payment-download-btn"
            onClick={() => handlePaymentSlipDownload(purchase)}
          >
            Download
          </button>
        </td>
      </tr>
    );
  })}
</tbody>

        </table>
      </div>
    )}
  </div>
)}


{/*************************************************** Inquiry / Feedback **************************************************************/}

              {selectedOption === "letter" && (
                <>
                  <h1 className="student-panel-title">Letter / Inquiry</h1>
                  <form className="contact-form" onSubmit={handleSend}>
                    <label className="form-label">Your Email</label>
                    <input
                      type="email"
                      value={studentEmail}
                      readOnly
                      className="form-input read-only"
                    />

                    <label className="form-label">Message Type</label>
                    <select
                      value={messageType}
                      onChange={(e) => setMessageType(e.target.value)}
                      className="form-input"
                    >
                      <option value="inquiry">Inquiry</option>
                      <option value="request">Request</option>
                      <option value="complaint">Complaint</option>
                      <option value="feedback">Feedback</option>
                    </select>

                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      placeholder="Enter subject"
                      className="form-input"
                      required
                    />

                    <label className="form-label">Message</label>
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Write your message here"
                      className="form-textarea"
                      required
                    ></textarea>

                    <div className="form-buttons">
                      <button type="button" className="clear-button" onClick={handleClear}>
                        Clear
                      </button>
                      <button type="submit" className="send-button">
                        Send
                      </button>
                    </div>
                  </form>
                </>
              )}



      </div>
    </div>

  );
};

export default CustomerDashboard;
